import { faDesktop, faEdit, faEnvelope, faGlobe, faPaperclip, faPhoneSquare } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FormElement, Form } from '@progress/kendo-react-form'
import DefaultButton from 'components/Buttons/DefaultButton/DefaultButton'
import SaveButton from 'components/Buttons/SaveButton/SaveButton'
import { DEFAULT_PERMISSION_MESSAGE } from 'core/consts'
import { focusFirstError } from 'core/helpers'
import { EditDealerSectionTypeEnum } from 'pages/Dealers/Edit/DealersEditPage'
import { useRef } from 'react'
import { Badge, Col, Row } from 'react-bootstrap'

interface IProps {
    editable: boolean
    formIsModified: boolean
}

const SummaryForm = ({ editable }: IProps) => {

    const dealerData = {
        company: 'Dealer Car Search Demo',
        address: '9420 Bunsen Parkway',
        cityStateZip: 'Louisville, KY, 40220',
        dealerId: '30',
        dealerGroupId: '230',
        dealerType: 'Franchise',
        phone: '502-326-8413',
        website: 'https://www.dcsdemo.com/',
        guidWebsite: 'https://4dfefdff-ba54-4ce3-8ee3-19bb6f3520da.dcs-mvc.com',
    }
    function changeSection(ATTACHMENTS: EditDealerSectionTypeEnum): void {
        throw new Error('Function not implemented.')
    }

    return (
        <div id='SummaryForm'>
            <Form
                ignoreModified={true}
                render={(formRenderProps) => (
                    <FormElement>
                        <div className='shadow-sm p-3 border pb-5'>
                            <Row>
                                <Col md={6}><h4>Summary</h4></Col>
                                <Col md={6} className='text-start text-md-end' style={{ alignSelf: 'center' }}>
                                    {/* place right aligned element here if needed */}
                                </Col>
                            </Row>
                            <hr />
                            <Row className='mt-3'>
                                <Col xs={12}>
                                    <Row>
                                        <Col lg={12} className='mb-3'>
                                            <Row>
                                                <Col xs={6}>
                                                    <div className='bg-light rounded shadow-sm border w-100 p-3 cursor-pointer' title='View Open Cases'>
                                                        <Row>
                                                            <Col md={6} className='text-md-start text-center'><h5 className='caseH5'>OPEN CASES:</h5></Col>
                                                            <Col md={6} className='text-md-end text-center'><h5 className='caseH5'>3</h5></Col>
                                                        </Row>
                                                    </div>
                                                </Col>
                                                <Col xs={6}>
                                                    <div className='bg-light rounded shadow-sm border w-100 p-3 cursor-pointer' title='View Closed Cases'>
                                                        <Row>
                                                            <Col md={6} className='text-md-start text-center'><h5 className='caseH5'>CLOSED CASES:</h5></Col>
                                                            <Col md={6} className='text-md-end text-center'><h5 className='caseH5'>9</h5></Col>
                                                        </Row>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col lg={9} className='mb-3'>
                                            <div className='bg-white p-3 border rounded shadow-sm h-100 dealerInfo'>
                                                <Row>
                                                    <Col xs={7}>
                                                        <b>Dealer Information:</b>
                                                    </Col>
                                                    <Col xs={5} className='text-end'>
                                                        <DefaultButton variant='default' className='btn-sm' title='Edit'><FontAwesomeIcon icon={faEdit} /></DefaultButton>
                                                    </Col>
                                                </Row>
                                                <hr />
                                                {dealerData.company}<br />
                                                {dealerData.address}<br />
                                                {dealerData.cityStateZip}<br />
                                                <a style={{ textDecoration: 'none', fontWeight: 'bold' }} href='tel:502-326-8413'><FontAwesomeIcon icon={faPhoneSquare} />{' '}{dealerData.phone}</a><hr />
                                                <a style={{ textDecoration: 'none' }} href='https://www.dcsdemo.com' target='_blank'><FontAwesomeIcon icon={faDesktop} /> {' '}{dealerData.website}</a><br />
                                                {/* The GUID url link should be to the current published website */}
                                                <a style={{ textDecoration: 'none' }} href='https://4dfefdff-ba54-4ce3-8ee3-19bb6f3520da.dcs-mvc.com/' target='_blank'><FontAwesomeIcon icon={faGlobe} /> {' '}{dealerData.guidWebsite}</a>
                                            </div>
                                        </Col>
                                        <Col lg={3} className='mb-3'>
                                            <div className='bg-white p-3 border rounded shadow-sm text-center w-100 mb-2'>
                                                {/* This number will require some math & code to get the total dealer value */}
                                                <div className=''>
                                                    Monthly Value:
                                                    <h3>$149.00</h3>
                                                </div>
                                            </div>
                                            <div className='bg-white p-3 border rounded shadow-sm text-center w-100 mb-2'>
                                                <div className=''>
                                                    Inventory Count:
                                                    <h3>136</h3>
                                                </div>
                                            </div>
                                            <div className='bg-white p-3 border rounded shadow-sm text-center w-100'>
                                                <div className=''>
                                                    Lead Count:
                                                    <h3>24,473</h3>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col lg={6} className='mb-3'>
                                            <div className='bg-white p-3 border rounded shadow-sm h-100 w-100'>
                                                <Row>
                                                    <Col xs={7}>
                                                        <b>Products:</b>
                                                    </Col>
                                                    <Col xs={5} className='text-end'>
                                                        <a href='https://fs25.formsite.com/ebaymarketplaces/form87/?37=DealerCarSearch' target='_blank' className='btn btn-sm btn-default me-2' title='Request Form'>eBay Contract Request Form</a>
                                                        <DefaultButton variant='default' className='btn-sm' title='Edit'><FontAwesomeIcon icon={faEdit} /></DefaultButton>
                                                    </Col>
                                                </Row>
                                                <hr />
                                                {/* replace this table with kendo react grid */}
                                                <Row>
                                                    <Col xs={6}>
                                                        <div className='bg-light p-3 border rounded shadow-sm text-center w-100 mb-2'>
                                                            <div className=''>
                                                                Primary Product:<br />
                                                                <b>$200 DCS</b>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col xs={6}>
                                                        <div className='bg-light p-3 border rounded shadow-sm text-center w-100 mb-2'>
                                                            <div className=''>
                                                                Owner:<br />
                                                                <b>Daniel Martin</b>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col xs={6}><DefaultButton variant='default' className='btn-sm w-100 mb-2' title='Change Order'>Change Order</DefaultButton></Col>
                                                    <Col xs={6}><DefaultButton variant='default' className='btn-sm w-100 mb-2' title='Upsell Pending Products'>Upsell Pending Products</DefaultButton></Col>
                                                    <Col xs={6}><DefaultButton variant='default' className='btn-sm w-100 mb-2' title='Change Contract Date'>Change Contract Date</DefaultButton></Col>
                                                    <Col xs={6}><DefaultButton variant='default' className='btn-sm w-100 mb-2' title='Change Status'>Change Status</DefaultButton></Col>
                                                </Row>
                                            </div>
                                        </Col>
                                        {/* if account access notes are empty hide entire section */}
                                        <Col lg={6} className='mb-3'>
                                            <div className='bg-white p-3 border rounded shadow-sm h-100 w-100'>
                                                <Row>
                                                    <Col xs={7}>
                                                        <b>Account Access Notes:</b>
                                                    </Col>
                                                    <Col xs={5} className='text-end'>
                                                        <DefaultButton variant='default' className='btn-sm' title='Edit'><FontAwesomeIcon icon={faEdit} /></DefaultButton>
                                                    </Col>
                                                </Row>
                                                <hr />
                                                <p>Notes will go here. If notes are not found this section will not show.</p>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>

                            <Row>
                                <Col lg={6} className='mb-3'>
                                    <div className='bg-white p-3 border shadow-sm h-100'>
                                        <Row>
                                            <Col xs={5}>
                                                <b>Contract Status:</b>
                                            </Col>
                                            <Col xs={7} className='text-end'>
                                                <DefaultButton variant='default' className='btn-sm me-1' title='View Attachments'><FontAwesomeIcon icon={faPaperclip} />{' '}Attachments</DefaultButton>
                                                <DefaultButton variant='default' className='btn-sm' title='Edit'><FontAwesomeIcon icon={faEdit} /></DefaultButton>
                                            </Col>
                                        </Row>
                                        <hr />
                                        <Row>
                                            <Col lg={6} className='mb-1 mb-lg-2'>
                                                Status:<br />
                                                <Badge className='bg-light text-start border w-100 p-2'>In Contract</Badge>
                                            </Col>
                                            <Col lg={6} className='mb-1 mb-lg-2'>
                                                Contract Reason:<br />
                                                <Badge className='bg-light text-start border w-100 p-2'>New Customer Discount</Badge>
                                            </Col>
                                            <Col lg={6} className='mb-1 mb-lg-2'>
                                                Start Date:<br />
                                                <Badge className='bg-light text-start border w-100 p-2'>2/15/2024</Badge>
                                            </Col>
                                            <Col lg={6}>
                                                End Date:<br />
                                                <Badge className='bg-light text-start border w-100 p-2'>4/15/2025</Badge>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                                <Col lg={6} className='mb-3'>
                                    <div className='bg-white p-3 border shadow-sm h-100'>
                                        <Row>
                                            <Col xs={7}>
                                                <b>Dealer Contacts:</b>
                                            </Col>
                                            <Col xs={5} className='text-end'>
                                                <DefaultButton variant='default' className='btn-sm' title='Edit'><FontAwesomeIcon icon={faEdit} /></DefaultButton>
                                            </Col>
                                        </Row>
                                        <hr />
                                        {/* replace this table with kendo react grid */}
                                        <table className='w-100 table'>
                                            <tbody>
                                                <tr>
                                                    <td>John Testerson</td>
                                                    <td><a style={{ textDecoration: 'none' }} href='tel:555-233-8282' target='_blank'><FontAwesomeIcon icon={faPhoneSquare} />{' '}555-233-8282</a></td>
                                                    <td><a style={{ textDecoration: 'none' }} href='mailto:john@mydealership.com' target='_blank'><FontAwesomeIcon icon={faEnvelope} />{' '}john@mydealership.com</a></td>
                                                </tr>
                                                <tr>
                                                    <td>Bob Smith</td>
                                                    <td><a style={{ textDecoration: 'none' }} href='tel:555-233-2828' target='_blank'><FontAwesomeIcon icon={faPhoneSquare} />{' '}555-233-2828</a></td>
                                                    <td><a style={{ textDecoration: 'none' }} href='mailto:bob@mydealership.com' target='_blank'><FontAwesomeIcon icon={faEnvelope} />{' '}bob@mydealership.com</a></td>
                                                </tr>
                                                <tr>
                                                    <td>Terrance Jones</td>
                                                    <td><a style={{ textDecoration: 'none' }} href='tel:555-233-2828' target='_blank'><FontAwesomeIcon icon={faPhoneSquare} />{' '}555-233-1972</a></td>
                                                    <td><a style={{ textDecoration: 'none' }} href='mailto:terrance@mydealership.com' target='_blank'><FontAwesomeIcon icon={faEnvelope} />{' '}terrance@mydealership.com</a></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </Col>
                            </Row>
                        </div>

                    </FormElement>

                )
                }
            />
        </div >
    )
}
export default SummaryForm

